import { Span, Text } from "@clipboard-health/ui-components";
import { CountryCode, formatPhoneNumberWithCode } from "@src/appV2/lib/utils/formatPhoneNumber";

interface StepUpAuthConfirmationTextProps {
  phoneNumber: string;
}

export function StepUpAuthConfirmationText(props: StepUpAuthConfirmationTextProps) {
  const { phoneNumber } = props;

  return (
    <Text>
      To proceed, you will need to confirm your identity by entering a verification code sent to
      your phone number:{" "}
      <Span sx={{ whiteSpace: "nowrap" }}>
        <b>{formatPhoneNumberWithCode({ phoneNumber, countryCode: CountryCode.US })}</b>
      </Span>
    </Text>
  );
}
